import {
    getApplicationAccount,
    listApplicationAccounts
} from './queries';
import {
    createApplicationAccount,
    deleteApplicationAccount,
    updateApplicationAccount,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {ApplicationAccount} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListApplicationAccounts = {
    listAccountApplications: { items: ApplicationAccount[] }
}

export type GetApplicationAccount = {
    getAccountApplication: ApplicationAccount
}

export type CreateApplicationAccount = {
    createAccountApplication: ApplicationAccount
}

export type UpdateApplicationAccount = {
    updateAccountApplication: ApplicationAccount
}

export type DeleteApplicationAccount = {
    deleteAccountApplication: string
}

const client = generateClient();


export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListApplicationAccounts>>({
                                                                                     query: listApplicationAccounts,
                                                                                     variables: {filter: filter},
                                                                                 });
    return response.data?.listAccountApplications.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetApplicationAccount>>({
                                                                                   query: getApplicationAccount,
                                                                                   variables: {id: id},
                                                                               });
    return response.data?.getAccountApplication;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateApplicationAccount>>({
                                                                                      query: createApplicationAccount,
                                                                                      variables: {input: payload},
                                                                                  });
    return response.data?.createAccountApplication;
};

export const update = async (_id: string, record: ApplicationAccount) => {

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateApplicationAccount>>({
                                                                                      query: (updateApplicationAccount),
                                                                                      variables: {input: record},
                                                                                  });
    return response.data?.updateAccountApplication;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteApplicationAccount>>({
                                                                                      query: (deleteApplicationAccount),
                                                                                      variables: {input: {id: id}},

                                                                                  });
    return response.data?.deleteAccountApplication;
};
